module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {
	
	fox.registerWidget('DependentPreloader', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					preloader: {
						widget: 'Widget',
						autoRender: false,
						template: 'big_preloader',
						group: 'visual'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.dependentTarget = this.wom1(this.requireOption('dependentTarget'));
			this.sponsorTarget = this.wom1(this.requireOption('sponsorTarget'));

			if (fox.oop.instanceOf(this.sponsorTarget, 'Api')) {
				this.preloaderStartExciter = 'prepare';
				this.preloaderStopExciter = ['success', 'error', 'failure'];
			} else if (fox.oop.instanceOf(this.sponsorTarget, 'Datalayer')) {
				this.preloaderStartExciter = 'loading';
				this.preloaderStopExciter = 'loaded';
			} else {
				this.preloaderStartExciter = this.requireOption('preloaderStartExciter');
				this.preloaderStopExciter = this.requireOption('preloaderStopExciter');
			}

			this.dependentTarget._readyToRender = false;
			this.dependentTarget._readyToEmbed = false;

			this.handleEvent(this.sponsorTarget, this.preloaderStartExciter, 'showPreloader', {alwaysActive: true, prefix: 'handle_' + this.sponsorTarget.getId()});
			this.handleEvent(this.sponsorTarget, this.preloaderStopExciter, 'renderDependentTarget');

			this.registerOptions('#preloader', {
				'embed.container': this.dependentTarget.getOption('container') || this.dependentTarget.getOption('embed.container'),
				'embed.widget': ['@parent', '@parent', this.dependentTarget.getOption('embed.widget')].join(' ')
			});
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.rwom1('#preloader')._readyToRender = false;
			this.rwom1('#preloader')._readyToEmbed = false;	
			this.callParent('running', arguments);
		},

		renderDependentTarget: function () {
			if (this.skipDrawing === true) {
				return false;
			}
			
			this.dependentTarget._readyToRender = true;
			this.dependentTarget._readyToEmbed = true;
			this.dependentTarget.render();
			this.waitEvent(this.dependentTarget, 'addedToDom', function (p, scope) {
				scope._readyToRender = false;
				scope._readyToEmbed = false;
			}, {prefix: 'preloaderAction'});
		},

		showPreloader: function () {
			var
				preloader = this.rwom1('#preloader');

			if (this.skipDrawing === true) {
				return false;
			}

			preloader.visualParent = preloader.rwom1(preloader.getOption('embed.widget'));

			if (!this.dependentTarget.isActive()) {
				return false;
			}

			preloader._readyToRender = true;
			preloader._readyToEmbed = true;

			if (!preloader.isActive()) {
				preloader.activate();
			}

			if (preloader.visualParent.isEmbedded()) {
				preloader.render();
			} else {
				this.waitEvent(preloader.visualParent, 'addedToDom', fox.bind(preloader.render, preloader));
			}

			this.waitEvent(preloader, 'addedToDom', function () {
				preloader._readyToRender = false;
				preloader._readyToEmbed = false;
			});
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/dependentPreloader.js
// module id = 308
// module chunks = 2